/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InstructionReminderOccurrenceDto } from './InstructionReminderOccurrenceDto';
import {
    InstructionReminderOccurrenceDtoFromJSON,
    InstructionReminderOccurrenceDtoFromJSONTyped,
    InstructionReminderOccurrenceDtoToJSON,
    InstructionReminderOccurrenceDtoToJSONTyped,
} from './InstructionReminderOccurrenceDto';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';

/**
 * 
 * @export
 * @interface InstructionReminderOccurrenceListResponseDto
 */
export interface InstructionReminderOccurrenceListResponseDto {
    /**
     * Reminder occurrences for the instruction
     * @type {Array<InstructionReminderOccurrenceDto>}
     * @memberof InstructionReminderOccurrenceListResponseDto
     */
    occurrences: Array<InstructionReminderOccurrenceDto>;
    /**
     * Pagination information
     * @type {PaginationDto}
     * @memberof InstructionReminderOccurrenceListResponseDto
     */
    pagination: PaginationDto;
}

/**
 * Check if a given object implements the InstructionReminderOccurrenceListResponseDto interface.
 */
export function instanceOfInstructionReminderOccurrenceListResponseDto(value: object): value is InstructionReminderOccurrenceListResponseDto {
    if (!('occurrences' in value) || value['occurrences'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function InstructionReminderOccurrenceListResponseDtoFromJSON(json: any): InstructionReminderOccurrenceListResponseDto {
    return InstructionReminderOccurrenceListResponseDtoFromJSONTyped(json, false);
}

export function InstructionReminderOccurrenceListResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstructionReminderOccurrenceListResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'occurrences': ((json['occurrences'] as Array<any>).map(InstructionReminderOccurrenceDtoFromJSON)),
        'pagination': PaginationDtoFromJSON(json['pagination']),
    };
}

export function InstructionReminderOccurrenceListResponseDtoToJSON(json: any): InstructionReminderOccurrenceListResponseDto {
    return InstructionReminderOccurrenceListResponseDtoToJSONTyped(json, false);
}

export function InstructionReminderOccurrenceListResponseDtoToJSONTyped(value?: InstructionReminderOccurrenceListResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'occurrences': ((value['occurrences'] as Array<any>).map(InstructionReminderOccurrenceDtoToJSON)),
        'pagination': PaginationDtoToJSON(value['pagination']),
    };
}

